import { useEffect, useState } from "react";

export default function useInternetStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

useEffect(() => {
  const handleOnline = () => {
    console.log("Back online");
    setIsOnline(true);
  };

  const handleOffline = () => {
    console.log("You are offline");
    setIsOnline(false);
  };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
}
